import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-erro404',
  templateUrl: './erro404.component.html',
  styleUrls: ['./erro404.component.scss']
})
export class Erro404Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  pageInicial() {
    sessionStorage.clear();
    window.location.href = '/';
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/erro-pages/erro404/erro404.component.ts